import React from 'react'
import Header from './Header';
import Footer from './Footer';
import PageBanner from './PageBanner';
import CssBaseline from '@mui/material/CssBaseline';

class FullPage extends React.Component{
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render(){
        const { page, noBanner, name } = this.props;
        let bckg = ""
        if(page === "login" || page === "home"){
            bckg = "gradient-purple"
        }
        // console.log('================FULL PAGE PROPS====================');
        // console.log(this.props);
        // console.log('====================================');
        return(
            <div className={bckg}>
                <CssBaseline />
                <Header currentPage={page}/>
                    {/* {!noBanner && <PageBanner page={page ? ("nav."+ page) : name} />} */}
                    <div className="min-height">
                        {this.props.children}
                    </div>
                <Footer {...this.props} admin={this.props.admin} toto={this.props.toto}/>
            </div>
        )
    }
}

export default FullPage;
